module.exports = __webpack_public_path__ + "img/parkingBanner.0e3a621e.png";